import { Container } from 'reactstrap';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ModifFormDoplnek from '../comp/ModifFormDoplnek';

function EditDoplnek () {
    let { doplnekId } = useParams();
    console.log("doplnekId "+doplnekId)

    const doplnky = useSelector((state: any) => state.allPrvky.doplnky);
    let doplnek_doplnekId = doplnky.find((dopl: any) => (dopl.id===doplnekId))  
    console.log("displaying doplnek")
    console.log(doplnek_doplnekId) 
    return(
        <Container>
            <ModifFormDoplnek edit={true} doplnek={doplnek_doplnekId}/>
        </Container>)
}
export default EditDoplnek